export const FALLBACK_CATEGORIES = [
	{ id: "balloon-bouquets", label: "Balloon Bouquets", slug: "balloon-bouquets" },
	{ id: "gift-baskets", label: "Gift Baskets", slug: "gift-baskets" },
	{ id: "balloon-arches", label: "Balloon Arches", slug: "balloon-arches" },
];

export const FALLBACK_PRODUCTS = [
	{
		id: "prod_UKXry1ygenZRKe",
		slug: "simple-balloon-bouquet",
		title: "Simple Balloon Bouquet",
		description: "",
		price: 24.99,
		priceId: "price_1TLslKBeNw36E3il9pe0j18c",
		images: [],
		category: "balloon-bouquets",
		categoryLabel: "Balloon Bouquets",
		details: [],
		sortOrder: 1,
	},
	{
		id: "prod_UKXxFI1K44ZBPA",
		slug: "premium-balloon-bouquet",
		title: "Premium Balloon Bouquet",
		description: "",
		price: 62.95,
		priceId: "price_1TLsrlBeNw36E3il8xAliY2M",
		images: [],
		category: "balloon-bouquets",
		categoryLabel: "Balloon Bouquets",
		details: [],
		sortOrder: 2,
	},
	{
		id: "prod_UN9IeVtDCVDeEX",
		slug: "premium-housewarming-basket",
		title: "Premium Housewarming Basket",
		description: "",
		price: 189.99,
		priceId: "price_1TOP04BeNw36E3ilu632vOc1",
		images: [],
		category: "gift-baskets",
		categoryLabel: "Gift Baskets",
		details: [],
		sortOrder: 1,
	},
	{
		id: "prod_UM3YzlyU70P2EL",
		slug: "housewarming-basket",
		title: "Housewarming Basket",
		description: "",
		price: 144.99,
		priceId: "price_1TNLRBBeNw36E3ilMkQFvYH3",
		images: [],
		category: "gift-baskets",
		categoryLabel: "Gift Baskets",
		details: [],
		sortOrder: 2,
	},
	{
		id: "prod_UM2NHwaEKRDBlZ",
		slug: "care-basket",
		title: "Care Basket",
		description: "",
		price: 119.99,
		priceId: "price_1TNKIIBeNw36E3ilbkKWLcDI",
		images: [],
		category: "gift-baskets",
		categoryLabel: "Gift Baskets",
		details: [],
		sortOrder: 3,
	},
	{
		id: "prod_UN9oDSeBd0UgYJ",
		slug: "love-basket",
		title: "Love Basket",
		description: "",
		price: 169.99,
		priceId: "price_1TOPUsBeNw36E3iliEngheYe",
		images: [],
		category: "gift-baskets",
		categoryLabel: "Gift Baskets",
		details: [],
		sortOrder: 4,
	},
	{
		id: "prod_UN9tgIzzBQ08jV",
		slug: "baby-boy-basket",
		title: "Baby Boy Basket",
		description: "",
		price: 114.99,
		priceId: "price_1TOPZzBeNw36E3ilbgcLyxfZ",
		images: [],
		category: "gift-baskets",
		categoryLabel: "Gift Baskets",
		details: [],
		sortOrder: 5,
	},
	{
		id: "prod_UNAM3zB2q1ljXo",
		slug: "baby-girl-basket",
		title: "Baby Girl Basket",
		description: "",
		price: 119.99,
		priceId: "price_1TOQ1cBeNw36E3il2uXZqcPD",
		images: [],
		category: "gift-baskets",
		categoryLabel: "Gift Baskets",
		details: [],
		sortOrder: 6,
	},
	{
		id: "prod_UNxMCcbD39ZaR8",
		slug: "neutral-baby-basket",
		title: "Neutral Baby Basket",
		description: "",
		price: 119.99,
		priceId: "price_1TPBRPBeNw36E3ilhgmxW2sc",
		images: [],
		category: "gift-baskets",
		categoryLabel: "Gift Baskets",
		details: [],
		sortOrder: 7,
	},
	{
		id: "prod_UNxRxmblfspE7u",
		slug: "baked-basket",
		title: "Baked Basket",
		description: "",
		price: 124.99,
		priceId: "price_1TPBWwBeNw36E3il80kfYDr5",
		images: [],
		category: "gift-baskets",
		categoryLabel: "Gift Baskets",
		details: [],
		sortOrder: 8,
	},
	{
		id: "prod_UOjGS9PeQeCBMM",
		slug: "premium-tequila-basket",
		title: "Premium Tequila Basket",
		description: "",
		price: 239.99,
		priceId: "price_1TPvnsBeNw36E3ilcWK4xvdA",
		images: [],
		category: "gift-baskets",
		categoryLabel: "Gift Baskets",
		details: [],
		sortOrder: 9,
	},
	{
		id: "prod_ULfCg9cvtBaWdw",
		slug: "5ft-backdrop-one-sided",
		title: "5ft Backdrop + one-sided balloon garland",
		description: "",
		price: 300.0,
		priceId: "price_1TMxsZBeNw36E3il4d8sE5GC",
		images: [],
		category: "balloon-arches",
		categoryLabel: "Balloon Arches",
		details: [],
		sortOrder: 1,
	},
	{
		id: "prod_ULfEddaOgu8teu",
		slug: "6ft-backdrop-one-sided",
		title: "6ft Backdrop + one-sided balloon garland",
		description: "",
		price: 350.0,
		priceId: "price_1TMxuJBeNw36E3ilqu8JyEuh",
		images: [],
		category: "balloon-arches",
		categoryLabel: "Balloon Arches",
		details: [],
		sortOrder: 2,
	},
	{
		id: "prod_ULfRdXBzTTyBHz",
		slug: "6ft-backdrop-both-sides",
		title: "6ft Backdrop + Balloon Garlands on both sides",
		description: "",
		price: 500.0,
		priceId: "price_1TMy69BeNw36E3ilvjmBX7xK",
		images: [],
		category: "balloon-arches",
		categoryLabel: "Balloon Arches",
		details: [],
		sortOrder: 3,
	},
	{
		id: "prod_ULfVcum0OxiXLE",
		slug: "5ft-backdrop-both-sides",
		title: "5ft Backdrop + Balloon Garlands on both sides",
		description: "",
		price: 450.0,
		priceId: "price_1TMyAABeNw36E3ilCETEbk7j",
		images: [],
		category: "balloon-arches",
		categoryLabel: "Balloon Arches",
		details: [],
		sortOrder: 4,
	},
	{
		id: "prod_UNxEo88NfA6UPP",
		slug: "premium-6ft-5ft-backdrop",
		title: "Premium 6ft+5ft Backdrop + Balloon Garlands for each arch",
		description: "",
		price: 600.0,
		priceId: "price_1TPBKKBeNw36E3ilzkU5g4r8",
		images: [],
		category: "balloon-arches",
		categoryLabel: "Balloon Arches",
		details: [],
		sortOrder: 5,
	},
];
